// @flow

import * as React from 'react';
import Box from 'sail/Box';
import type {Article} from 'docs/data';
import {createStripeInternalUrl} from 'docs/util';
import {BodyAlt} from 'sail/Text';
import Group from 'sail/Group';
import {XRaySidebarLink} from './XRaySidebarLink';

type ConditionsListItemsProps = {|
  type: string,
  keys: Array<string>,
  article: Article,
|};

const getLink = (type, condition): Object => {
  switch (type) {
    case 'gate':
      return {
        label: 'View on Admin',
        href: createStripeInternalUrl('gates', {gate: condition}),
      };
    case 'flag':
      return {
        label: 'View on Amp',
        href: createStripeInternalUrl('flags', {flag: condition}),
      };
    case 'core': {
      const root = 'docs/lib/';
      const filename = `conditions/core/${condition}.rb`;
      return {
        label: 'View on GitHub',
        href: createStripeInternalUrl('github', {root, filename}),
      };
    }
    default: {
      const root = 'docs/lib/';
      const filename = `conditions/contrib/${condition}.rb`;
      return {
        label: 'View on GitHub',
        href: createStripeInternalUrl('github', {root, filename}),
      };
    }
  }
};

export const ConditionsListItems = ({
  type,
  keys,
  article,
}: ConditionsListItemsProps): Array<React.Node> => {
  if (!article.xray) {
    return [];
  }

  const list = keys.map((condition): React.Node => {
    const linkProps = getLink(type, condition);
    const label = type === 'contrib' || type === 'core' ? 'custom' : type;

    return (
      <Box key={condition} style={{wordBreak: 'break-word'}}>
        <Group spacing={4}>
          <BodyAlt>
            [{label}] {condition}
          </BodyAlt>
          <XRaySidebarLink key={condition} {...linkProps} />
        </Group>
      </Box>
    );
  });
  return list;
};
